module.exports = __webpack_public_path__ + "img/orb_of_destruction.6fa904e5.png";